import * as _ from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';

import * as onboardingForm from 'login-utils/onboardingForm';
import States from 'login-constants/states';
import * as deploymentConfig from 'login-utils/deploymentConfig';
import LoginLink from '../LoginLink/LoginLink';
import { getTimelineChooserConfig } from './JourneyChooser';

interface Props {
  selectedTimelineValue: onboardingForm.TimelineValue | null;
}

const validTimelineMap: Partial<Record<onboardingForm.TimelineValue, onboardingForm.TimelineValue>> = _.keyBy([
  'REFINANCE',
  'NOT_STARTED',
]);

export class JourneyChooserTop extends React.Component<Props, {}> {
  render() {
    const { selectedTimelineValue } = this.props;
    const { showUpFrontRatesInJourneyChooser } = deploymentConfig.get();
    const shouldShowLink = !!(showUpFrontRatesInJourneyChooser && validTimelineMap[selectedTimelineValue!]);
    return shouldShowLink ? (
      <LoginLink href={`/${States.SHORT_FORM}`}>Just rate shopping? View today's rates</LoginLink>
    ) : null;
  }
}

const mapStateToProps = (state, _props) => {
  const journeyOption = onboardingForm.getTimelineValue(state);
  return {
    selectedTimelineValue: _.get(
      getTimelineChooserConfig(journeyOption),
      'value',
      null,
    ) as onboardingForm.TimelineValue | null,
  };
};

export default connect(mapStateToProps)(JourneyChooserTop);
